import { storeToRefs } from "pinia";
import { computed } from "vue";

import useTeamPicker from "shared/composables/useTeamPicker";
import features from "shared/services/features";
import { useUserStore } from "shared/stores/user";

export default function useFilteredTeam() {
  const userStore = useUserStore();
  const { team, currentUser } = storeToRefs(userStore);
  const { selectedTeamPreference } = useTeamPicker();

  const organisationUsers = (organisationTeamId) => {
    if (features.has("has_team_workspaces")) {
      return team.value.filter(
        (user) =>
          user.organisation_teams.some(
            (organisationTeam) => organisationTeam.id === organisationTeamId
          ) ||
          user.role.name === "super" ||
          !organisationTeamId
      );
    }

    return team.value;
  };

  const teamUsers = computed(() =>
    organisationUsers(selectedTeamPreference.value)
  );

  const organisationUsersWithSelf = (organisationTeamId) =>
    [currentUser.value].concat(organisationUsers(organisationTeamId));

  return {
    teamUsers,
    organisationUsersWithSelf,
  };
}
